<template>
  <header>
    <div class="header-logo">
      <div class="box">
        <div class="logo">
          <router-link to="/"><img title="Iveco" src="../images/logo_iveco_hk.png"></router-link>
        </div>
        <button type="button" class="navbar-toggle" :class="collapsed ? '' : 'collapsed' " @click="collapsed = !collapsed" >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar top-bar"></span>
          <span class="icon-bar middle-bar"></span>
          <span class="icon-bar bottom-bar"></span>
        </button>
        <div class="navbar-phone" :class="collapsed ? '' : 'collapsed' ">
          <a href="tel:852-2119-4809">
            <i class="iconfont">&#xe602;</i>
          </a>
        </div>
        <div class="text">
          <a href="tel:852-2119-4809">
            <span class=""></span>
          </a>
        </div>
      </div>
    </div>
    <div class="header-navbar" v-show="collapsed">
      <div class="box">
        <div class="header-search" style="visibility: hidden;">
          <div class="header-search-inner">
            <input id="searchBox" type="text" class="input-text" placeholder="搜索 IVECO 香港及澳門"/>
            <i class="input-go iconfont">&#xe673;</i>
          </div>
        </div>
        <div class="header-contact">
          <span><a href="tel:852-2119-4809" target="_self" class="hidden-xs">IVECO香港及澳門：+852 2119 4809</a></span>
          <!-- <span><a href="javascript:;" target="_self">連絡我們</a></span> -->
        </div>
      </div>
    </div>
    <el-collapse-transition>  
    <div class="nav-bg" v-show="collapsed">
      <!-- <div class="nav-type">
        <ul>
          <li :class="type == 1 ? 'hover' : ''" @click="switchType(1)"><a href="javascipt:;">MENU</a></li>
          <li :class="type == 2 ? 'hover' : ''" @click="switchType(2)"><a href="javascipt:;">IVECO FOR YOU</a></li>
        </ul>
      </div> -->
      <nav v-show="screenWidth > 768 ? true : type == 1 ? true : false">
        <!-- 一级菜单 -->
        <ul class="first-level-menu">
          <li class="has-sub-menu" @mouseenter="firstIsShow" @mouseleave="firstIsShow">
            <a href="javascript:;" @click="firstShow" :class="show ? 'hover' : '' ">產品<i class="iconfont down">&#xe6cc;</i></a>

            <!-- 第二-子 -->
            <el-collapse-transition>
            <div class="sub-menu-wrap" :class="{'hover' : show}"  v-show="mShow">
              <div class="sub-menu-inner">

               <!-- 二级菜单 -->
                <ul class="second-level-menu">
                  <li class="has-sub-menu" @mouseenter="secondIsShow(fu, index, 'in')"  @mouseleave="secondIsShow(fu, index, 'out')"  v-for="(fu, index) in carList" :key="index">
                    <a href="javascript:;" @click="secondShow(fu, index)" :class="num == index ? 'hover' : ''">{{fu.secondTitle}}<i class="iconfont down">&#xe6cc;</i></a>
                    
                    <!-- 第三-子 -->
                    <el-collapse-transition>
                    <!-- <div class="third-level-menu-wrap"  v-show="screenWidth < 992 ? fu.block : true" :class="num == index ? 'hover' : 'hover'"> -->
                    <div class="third-level-menu-wrap hover">
                      <!-- 三级菜单 -->
                      <ul class="third-level-menu">
                        <li>
                          <span class="category">{{fu.thirdTitle}}</span>

                          <!-- 四级菜单 -->
                          <ul class="fourth-level-menu">
                            <li v-for="child in fu.fourth" :key="child.index">
                              <router-link :to="'/products/' + child.href + '/'" class="" >
                                <div class="thumb-wrap">
                                  <img :src="child.img">
                                </div>
                                <div class="txt-wrap">{{child.txt}}</div>
                              </router-link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    </el-collapse-transition>
                  </li>
                </ul>
              </div>
            </div>
            </el-collapse-transition>
          </li>
          <!-- <li class="has-sub-menu"><a href="javascript:;">售服及零件</a></li> -->
          <li class="has-sub-menu"><router-link to="/news">最新資訊</router-link></li>
          <!-- <li class="has-sub-menu"><a href="javascript:;">關於IVECO</a></li> -->
          <!-- <li class="has-sub-menu"><a href="javascript:;">預約試駕</a></li> -->
          <li class="has-sub-menu"><router-link to="/contact">聯繫我們</router-link></li>
        </ul>
      </nav>
      <div class="nav-contact" v-show="screenWidth > 768 ? true : type == 2 ? true : false">
        <ul class="first-level-menu">
          <li><a href="tel:852-2119-4809" target="_self" class="hidden-xs">IVECO香港及澳門：852-2119-4809</a></li>
          <!-- <li><a href="javascript:;" target="_self">連絡我們</a></li> -->
        </ul>
      </div>
    </div>
    </el-collapse-transition>
  </header>
</template>

<script>
import Element from 'element-ui';  //Element插件

export default {
  name: 'Header',
  data () {
    return {
      screenWidth: document.body.clientWidth,

      show: false,
      secShow: false,
      num: 0,
      carList: [
        {secondTitle: '運輸類用車', thirdTitle: 'Light (3.5 - 7.2 t)', 
        fourth: [
          {id:'', txt: '全新DAILY貨VAN王', img: this.$store.state.baseURL + '/iveco/iveco-images/car/van-daily2019-iveco-menu.jpg', href: "new_daily_van"},
           {id:'', txt: '全新DAILY CAB車陣王', img: this.$store.state.baseURL + '/iveco/iveco-images/car/cab-daily2019-iveco-menu.jpg', href: "new_daily_cab"}
        ]},
        // {secondTitle: 'On Road2', thirdTitle: 'IVECO Daily 3.49 - 7噸22222', 
        // fourth: [
        //   {txt: 'Daily Van5', img: 'https://www.iveco.com/taiwan/publishingimages/menu/van-daily-iveco-menu.jpg', href: "javascipt:;"},
        //   {txt: 'Daily Van6', img: 'https://www.iveco.com/taiwan/publishingimages/menu/van-daily-iveco-menu.jpg', href: "javascipt:;"},
        //   {txt: 'Daily Van7', img: 'https://www.iveco.com/taiwan/publishingimages/menu/van-daily-iveco-menu.jpg', href: "javascipt:;"}
        // ]}
      ],

      collapsed: false,
      mShow: false,
      type: 1
    }
  },
  mounted () {
    let that = this

    window.onresize = () => {
      return (() => {
          window.screenWidth = document.body.clientWidth   
          that.screenWidth = window.screenWidth
      })()
    }
    that.getscreenWidth()
  },

  methods: {
    // 浏览器窗口大小
    getscreenWidth () {
      if (this.screenWidth >= 992) {
        this.collapsed = true
        this.mShow = true
        // console.log('123',  this.collapsed )
      } else {
        this.collapsed = false
        this.mShow = false
        // console.log('12334551',  this.collapsed )
        for (var i = 0; i < this.carList.length; i++) {
          this.$set(this.carList[i], 'block', false)
        }
      }
    },
    // Wed端
    firstIsShow () {
      this.show = !this.show
    },
    secondIsShow (fu, index,  t) {
      if (t == "in") {
        this.num = index
        // console.log('num', this.num)
        // console.log('fu', fu)
      } else if ( t == "out") {
      }
    },

    // 手机端
    collapseds () {
      if (this.screenWidth < 992) {
        this.collapsed = !this.collapsed
      }
    },
    firstShow () {
      if (this.screenWidth < 992) {
        this.mShow = !this.mShow
      } else {
        this.$router.push({path: '/'})
      }
    },
    secondShow (data, index) {
      if (this.screenWidth < 992) {
        data.block = !data.block
        // console.log('data', data)
      }
    },
    switchType (s) {
      this.type = s
    }
  },
  watch: {
    screenWidth (val) {
      // console.log('this.timer', this.timer)
      if (!this.timer) {
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
            // that.screenWidth = that.$store.state.canvasWidth
            // console.log(that.screenWidth)
            that.getscreenWidth()
            that.timer = false
        }, 400)
      }
    }
  }
}
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>

  .has-sub-menu a,
  .has-sub-menu span{
    color: #333;
    // text-transform: uppercase;
    text-decoration: none;
  }
  .has-sub-menu > a:hover {
    color: #333;
  }

  header {
    background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee 50%);
    background: -o-linear-gradient(top, #ffffff 0%, #eeeeee 50%);
    background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee 50%);
    background: linear-gradient(to bottom, #ffffff 0%, #eeeeee 50%);
    // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#eeeeee', GradientType=0);
    border: none;
    margin-bottom: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1010;
    max-height: 100%;
    overflow-y: auto;
    box-shadow: 0 0 15px 0 #999;
    .header-logo {
      float none; 
      overflow: hidden;
      .logo {
        position: relative;
        img {
          position: absolute;
          top: 8px;
          left: 0;
          max-width: 86px;
          z-index: 5;
        }
      }
      button {
        margin-top: 6px;
        margin-bottom: 5px;
        margin-right: 0;
        padding: 9px 3px;
        border: none;
        background: transparent !important;
        position: relative;
        float: right;
        border-radius: 0px;
        cursor: pointer;
      }
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
      }
      .icon-bar {
        margin-top: 4px;
        height: 3px;
        width: 26px;
        -webkit-transition: all 0.2s;
        -o-transition: all 0.2s;
        transition: all 0.2s;
        display: block;
        // width: 22px;
        // height: 2px;
        border-radius: 1px;
        background-color: #00336F;
      }
      // .navbar-toggle {
        // margin-top: 6px;
        // margin-bottom: 5px;
        // margin-right: 0;
        // padding: 9px 3px;
        // border: none;
        // background: transparent !important;
      // }
      .navbar-phone {
        width: 40px;
        height: 40px;
        margin-top: 9px;
        margin-right: 11px;
        float: right;
        // display: none;
        opacity: 0;
        -webkit-transition: all 0.2s;
        -o-transition: all 0.2s;
        transition: all 0.2s;
        a {
          display: block;
          text-align: center;
          .iconfont {
            font-size: 26px;
            color: #00336f;
          }
        }
      }
      .navbar-phone.collapsed {
        // display: block;
        opacity: 1;
      } 
      .navbar-toggle:hover {
        background: transparent !important;
      }
      .navbar-toggle .icon-bar {
        height: 3px;
        width: 26px;
        -webkit-transition: all 0.2s;
        -o-transition: all 0.2s;
        transition: all 0.2s;
      }
      .navbar-toggle .top-bar {
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
        -webkit-transform-origin: 10% 10%;
        -moz-transform-origin: 10% 10%;
        -ms-transform-origin: 10% 10%;
        transform-origin: 10% 10%;
      }
      .navbar-toggle .middle-bar {
        opacity: 0;
      }
      .navbar-toggle .bottom-bar {
        -webkit-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        transform: rotate(-45deg);
        -webkit-transform-origin: 10% 90%;
        -moz-transform-origin: 10% 90%;
        -ms-transform-origin: 10% 90%;
        transform-origin: 10% 90%;
      }
     .navbar-toggle.collapsed .top-bar {
        -webkit-transform: rotate(0);
        -ms-transform: rotate(0);
        -o-transform: rotate(0);
        transform: rotate(0);
      }
      .navbar-toggle.collapsed .middle-bar {
        opacity: 1;
      }
      .navbar-toggle.collapsed .bottom-bar {
        -webkit-transform: rotate(0);
        -ms-transform: rotate(0);
        -o-transform: rotate(0);
        transform: rotate(0);
      }
    }
    .header-navbar {
      height: 20px;
      // padding-bottom: 50px;
      padding-left: 0;
      padding-right: 0;
      position: relative;
      background-color: #ced5dd;
      overflow: hidden;
      .header-search {
        text-align: right;
        .header-search-inner {
          display: inline-block;
          width: 100%;
          position: relative;
          background: #e2e2e2;
          margin: 10px 0;
          .input-text {
            font-family: "GillSans";
            width: 100%;
            height: 32px;
            border: none;
            padding-left: 5px;
            background: #ebeef1;
          }
          .input-go {
            font-style: normal;
            text-align: center;
            color: #444;
            width: 40px;
            height: 32px;
            line-height: 32px;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
          }
        }
      }
      .header-contact {
        display: none;
        text-align: right;
        span {
          display: inline-block;
          a {
            display: block;
            // text-transform: uppercase;
            text-decoration: none;
            padding: 10px 20px;
            &:last-of-type {
              padding: 10px 0 8px 10px;
            }
          }
        }
      }
    }
  }
  
  .nav-contact {
    display: block;
    float: left;
    width: 100%;
    padding: 0 5px;
    li {
      border-bottom: 1px solid #b8bfc6;
      a {
        text-align: left;
        position: relative;
        padding: 10px 20px;
        display: block;
      }
    }
  }

  //第一菜单
  .nav-bg {
    width: 100%;
    background-color: #ced5dd;
    float: none;
    padding-bottom: 50px;
    overflow: hidden;
    nav {
      margin-right: auto;
      margin-left: auto;
      padding-left: 10px;
      padding-right: 10px;
      //第一菜单
      .first-level-menu {
        padding: 0;
        margin: 0;
        list-style: none;
        .has-sub-menu {
          border-bottom: 1px solid #b8bfc6;
          &:first-child {
            border-left: none;
          }
          a {
            text-align: left;
            position: relative;
            padding: 10px 20px;
            display: block;
            .down {
              font-size: 20px;
              font-weight: 600;
              color: #00336f;
              position: absolute;
              right: 8px;
              top: 8px;
            }
          }
        }
      } 
      // 子DIV
      .sub-menu-wrap {
        background-color: #dce1e6;
        width: 100%;
        display: none;
      }
    }
    .nav-type {
      font-size: 18px;
      list-style: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
      box-shadow: inset 0 -25px 25px -25px #999;
      li {
        float: left;
        width: 50%;
        padding: 10px 5px;
        text-align: center;
        // background: rgba(189, 196, 205, 0.4);
        a {
          font-family: GillSansBold, Arial, sans-serif;
          text-decoration: none;
          display: block;
          text-transform: uppercase;
          font-size: 14px;
          color: #929eae;
        }
        &.hover {
          background: #ced5dd;
          a {
            color: #00336F;
          }
        }
      }
    }
  }

  //第一菜单下，全部a标签
  .nav-bg nav .sub-menu-wrap {
    display: block;
  }

  //第二菜单
  .second-level-menu {
    position: relative;
  }

  //第三菜单
  .third-level-menu-wrap {
    background: #fff;
    .third-level-menu {
      li {
        border-bottom: 1px solid #b8bfc6;
        margin: 0 10px;
        span {    
          font-family: 'GillSansBold';
          display: block;
          padding: 10px 20px;
          font-weight: 600;
          background: #f5f6f8;
        }
        a {
          .txt-wrap {
            text-transform: uppercase;
          }
        }
      }
    }
  }

  .third-level-menu-wrap > .third-level-menu > li {
    margin: 0;
  }

  //第四菜单
  .fourth-level-menu {
    li {
      margin: 0 10px;
      a {
        padding: 5px 10px;
        display: flex !important;
        .thumb-wrap {
          max-width: 25%;
          padding-right: 5px;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
        .txt-wrap {
          padding: 10px 0;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }
      }
    }
  }


  //Top Nav
  @media (min-width: 768px) {
    .nav-bg {
      overflow: hidden;
      nav,
      .nav-contact {
        display: block;
        float: left;
        width: 50%;
        padding: 0 5px;
        li {
          border-bottom: 1px solid #b8bfc6;
          a {
            text-align: left;
            position: relative;
            padding: 10px 20px;
            display: block;
          }
        }
      }
      nav {
        .first-level-menu {
          .has-sub-menu {
            a {
              // .down {
              //   font-size: 20px;
              //   font-weight: 600;
              //   color: #00336f;
              //   position: absolute;
              //   right: 8px;
              //   top: 8px;
              // }
            }
          }
        }
      }
      .nav-type {
        box-shadow: none;
        li {
          background: none;
          a {
            color: #00336F;
          }
        }
      }
    }

    //第四菜单
    .fourth-level-menu {
      li {
        a {
          padding: 5px 10px !important;
          .thumb-wrap {
            max-width: 20%;
            vertical-align: middle;
            img {
              display: inline-block;
            }
          }
        }
      }
    }

  }
  @media (min-width: 992px) {
    header {
      box-shadow: none;
      position: relative;
      top: auto;
      left: auto;
      right: auto;
      z-index: auto;
      max-height: none;
      overflow-y: visible;
      min-height: 70px;
      .header-logo {
        overflow: visible;
        .logo {
          img {
            top: 10px !important;
            max-width: none;
            width: 120px;
          }
        }
        button {
          display: none;
        }
        .navbar-phone {
          display: none;
        }
      }
      .header-navbar {
        height: auto;
        margin: 0;
        background-color: transparent;
        overflow: visible;
        .header-search {
          .header-search-inner {
            width: 350px;
            margin: 0;
            .input-text {
              padding-right: 33px;
              background: #e2e2e2;
            }
            .input-go {
              width: 33px;
            }
          }
        }
        .header-contact {
          display: block;
          span {
            a {
              font-size: 13px;
              padding: 10px 8px;
            }
          }
        }
      }
    }

    //第一菜单下，全部a标签
    .nav-bg > nav > .first-level-menu > .has-sub-menu > a {
      display: block;
      color: #fff;
      text-align: center;
      padding: 8px 3px;
      &.hover {
        background: #e9e9e9;
        border-color: #e9e9e9;
        color: #333333;
      }
      &:hover {
        background: #e9e9e9;
        border-color: #e9e9e9;
        color: #333333;
      }
    }

    //第二菜单 a标签
    // .sub-menu-wrap a{
    //   background: #fff;
    // }

    .second-level-menu a.hover {
      background: #fff;
    }
    //第二菜单
    .second-level-menu {
      background: #c2c7ca;
    }

    //第三菜单
    .third-level-menu-wrap {
      display: none;
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      min-height: 190px;
      .third-level-menu {
        li {
          display: inline-block;
          border-bottom: none;
          margin: 0;
          // border-left: 1px dotted #777777;
          span {
            display: inline-block;
            background: none;
            padding: 10px;
          }
        }
      }
    }

    .third-level-menu-wrap.hover {
      display: block;
      background: #fff;
    } 

    //第四菜单
    .fourth-level-menu {
      li {
        margin: 0 10px;
        a {
          padding: 10px;
          display: block !important;
          .thumb-wrap {
            max-width: none;
          }
          .txt-wrap {
            padding: 0;
            display: block;
            text-align: center;
          }
        }
      }
    }

    //第一菜单
    .nav-bg {
      background-color : #000;
      padding-bottom: 0;
      nav {    
        padding-left: 10px;
        padding-right: 10px;
        float: none;
        // 一级菜单 
        .first-level-menu {
          display: table;
          width: 100%;
          .has-sub-menu {
            display: table-cell;
            vertical-align: middle;
            word-wrap: break-word;
            border-bottom: none;
            a {
              .down {
                display: none;
              }
            }
          }
        }
        .first-level-menu > .has-sub-menu {
          border-left: 2px solid #333;
        }
        
        // 子，第二菜单
        .sub-menu-wrap {
          background: none;
          position: absolute;
          top: 100%;
          left: 0;
          display: none;
          z-index: 1010;
        }
        .sub-menu-wrap.hover {
          display: block;
        }
      }
      .nav-contact {
        display: none;
      }
      .nav-type {
        display: none;
      }
    }


    .nav-bg nav .sub-menu-wrap .sub-menu-inner {
      margin-right: auto;
      margin-left: auto;
      padding-left: 10px;
      padding-right: 10px;
    }

    .nav-bg nav .sub-menu-wrap .sub-menu-inner > .navbar-header,
    .nav-bg nav .sub-menu-wrap .sub-menu-inner > .navbar-collapse {
      margin-right: -10px;
      margin-left: -10px;
    }

    .nav-bg nav .sub-menu-wrap .sub-menu-inner > .navbar-header,
    .nav-bg nav .sub-menu-wrap .sub-menu-inner > .navbar-collapse {
      margin-right: 0;
      margin-left: 0;
    }

  }
  @media (min-width: 1200px) {
    header {
      .header-logo {
        .text {
          display: none !important;
        }
      }
    }
  }


  //Nav窗口响应式
  @media (min-width: 992px) and (min-width: 768px) {
    .nav-bg nav,
    .nav-bg nav .sub-menu-wrap .sub-menu-inner {
      width: 740px;
    }
  }
  @media (min-width: 992px) and (min-width: 992px) {
    .nav-bg nav,
    .nav-bg nav .sub-menu-wrap .sub-menu-inner {
      width: 960px;
    }
  }
  @media (min-width: 992px) and (min-width: 1200px) {
    .nav-bg nav,
    .nav-bg nav .sub-menu-wrap .sub-menu-inner {
      width: 990px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue